import React from "react";
import AsyncSelect from "react-select/async";
import styled from "styled-components";

const StyledAsyncSelect = styled(AsyncSelect)`
  width: 100%;
`;

const styles = {
  control: (base) => ({
    ...base,
    width: "100%",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: "none",
  }),
};

const DropdownSearch = ({ ...rest }) => {
  return (
    <StyledAsyncSelect
      classNamePrefix="select"
      styles={styles}
      {...rest}
    />
  );
};

export default DropdownSearch;
